<div class="user">
  <div class="verification-info" (click)="toggleInfoModal()">
    <app-icon [width]="24" [height]="24" [file]="'unboarding'" [icon]="'info'"></app-icon>
  </div>
  <div class="user__picture">
    <on-ui-cover [cover]="avatar"></on-ui-cover>
  </div>

  <div class="user__meta">
    <div class="user__name">
      <ng-container *ngIf="isGuest; else authorized">
        <p>{{'onboarding.guest-title' | translate}}</p>
      </ng-container>

      <ng-template #authorized>
        <p>{{ userFullName }}</p>
      </ng-template>
    </div>
  </div>
</div>

<div class="info" [class.completed]="completed">
  <p class="title">{{(completed ? 'onboarding.completed-title' :'onboarding.info-title') | translate}}</p>
  <p class="description">{{(completed ? 'onboarding.completed-text' : 'onboarding.uncompleted-text') | translate}}</p>
</div>

<ng-container *ngIf="isInfoModalOpened">
<app-modal *ngIf="deviceService.isDesktop()"
           (closed)="toggleInfoModal()">
  <app-modal-body>
    <app-about-verification-widget [modal]="true"></app-about-verification-widget>
  </app-modal-body>
</app-modal>

<app-mobile-modal *ngIf="!deviceService.isDesktop()"
                  (closed)="toggleInfoModal()">
  <app-mobile-modal-body>
    <app-about-verification-widget [modal]="true"></app-about-verification-widget>
  </app-mobile-modal-body>
</app-mobile-modal>
</ng-container>
